/* eslint-disable react/no-danger */
import React, { memo, useMemo } from "react";
import InstagramPostPreview from "../../../../components/shared/messages/InstagramPostPreview";
import FacebookPostPreview from "../../../../components/shared/messages/FacebookPostPreview";
import MessageStatusMC from "./MessageStatusMC";
import GroupSenderMC from "./GroupSenderMC";

// TextMessageMC - Atom-level component
// Muestra el contenido del mensaje de texto junto con previews de Instagram y Facebook si están presentes.
// Optimizado con useMemo para evitar renders innecesarios.
const TextMessageMC = memo(({ message, conversation }) => {
  const instagramPreview = useMemo(
    () => (message.igUrl ? <InstagramPostPreview igUrl={message.igUrl} /> : null),
    [message.igUrl]
  );

  const facebookPreview = useMemo(
    () => (message.fbUrl && !message.igUrl ? <FacebookPostPreview url={message.fbUrl} /> : null),
    [message.fbUrl, message.igUrl]
  );

  const messageContent = useMemo(
    () => <div dangerouslySetInnerHTML={{ __html: message.messageText }} />,
    [message.messageText]
  );

  return (
    <div className="tw-wrapper tw-whitespace-pre-line tw-text-sm">
      <GroupSenderMC message={message} />
      {instagramPreview}
      {facebookPreview}
      {messageContent}
      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  );
});

TextMessageMC.displayName = 'TextMessageMC';

export default TextMessageMC;
